import * as ActionTypes from '../redux/ActionTypes';


export default (state=[], action) => {
	if (action.type === ActionTypes.SETBENNER) {
		return [ ...state, ...action.banners ]
	} else {
		return state;
	}
}

